import { useTranslation } from 'react-i18next';
import { BadgeCheck, Package, Recycle, ShieldCheck } from 'lucide-react';

export const TrustSignalsSection = () => {
  const { t } = useTranslation();

  return (
    <section
      className="bg-white dark:bg-slate-900 border-t border-b border-slate-200 dark:border-slate-800"
      data-testid="trust-signals-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="flex items-start gap-3">
            <BadgeCheck className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{t('home.trust.vies.title')}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{t('home.trust.vies.desc')}</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <ShieldCheck className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{t('home.trust.companies.title')}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{t('home.trust.companies.desc')}</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Package className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{t('home.trust.csv.title')}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{t('home.trust.csv.desc')}</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Recycle className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{t('home.trust.circular.title')}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{t('home.trust.circular.desc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
